<div [formGroup]="form">

    <kal-form-field *ngIf="isNominativeControlDisplayed"
                    class="without-label">

        <kal-radio-group formControlName="IsNominatif" class="kal-radio-group-control">
            <kal-radio [value]="false">Contrôler pour toute la famille</kal-radio>
            <kal-radio [value]="true">Contrôler nominativement</kal-radio>
        </kal-radio-group>

        @if (form.get('IsNominatif').value) {
            <p class="small gup-U-color--orange">
                En passant sur « Contrôler nominativement », la consommation des ayants-droit ne
                sera plus décomptée : le solde ne tiendra plus compte que de l'ouvrant-droit.
            </p>
        }

    </kal-form-field>

    <kal-form-field>

        <kal-radio-group class="kal-theme--bascule"
                         formControlName="IsFixe"
                         label="Type de subvention">

            <kal-radio [value]="true">
                Subvention fixe
            </kal-radio>

            <kal-radio [value]="false">
                Subvention variable selon critères
            </kal-radio>

        </kal-radio-group>

    </kal-form-field>

    <ng-container *ngIf="isFixe; else advancedMode">

        <ng-container *ngTemplateOutlet="subventionsErrorTemplate"></ng-container>
        <div *ngFor="let control of (rulesList.controls | slice: 0 : 1); index as i" formArrayName="ListeRegle">

            <div [formGroupName]="i"
                 class="liste-regle-fixe">

                <kal-form-field>
                    <kal-input [icon]="inputIcon"
                               [type]="inputType"
                               formControlName="Od"
                               label="Ouvrant droit">
                    </kal-input>
                </kal-form-field>

                <kal-form-field>
                    <kal-input [icon]="inputIcon"
                               [type]="inputType"
                               formControlName="Conjoint"
                               label="Conjoint">
                    </kal-input>
                </kal-form-field>

                <kal-form-field>
                    <kal-input [icon]="inputIcon"
                               [type]="inputType"
                               formControlName="Enfant"
                               label="Enfant">
                    </kal-input>
                    <div class="small gup-U-color--400">X nombre d’enfants</div>
                </kal-form-field>

                <kal-form-field>
                    <kal-input [icon]="inputIcon"
                               [type]="inputType"
                               formControlName="Externe"
                               label="Externes">
                    </kal-input>
                    <div class="small gup-U-color--400">X nombre d’externes</div>
                </kal-form-field>

                <kal-form-field>
                    <kal-input [icon]="inputIcon"
                               [type]="inputType"
                               formControlName="ValMin"
                               label="Valeur minimale">
                    </kal-input>
                </kal-form-field>

                <kal-form-field>
                    <kal-input [icon]="inputIcon"
                               [type]="inputType"
                               formControlName="ValMax"
                               label="Valeur maximale">
                    </kal-input>
                </kal-form-field>

            </div>

        </div>

    </ng-container>

    <ng-template #advancedMode>

        <kal-form-field class="gup-C-formFieldSize--select">
            <kal-select formControlName="IdChamp"
                        label="Critère"
                        placeholder="Sélectionner un critère">
                <kal-option *ngFor="let criterion of criteriaList"
                            [value]="criterion.Id">
                    {{criterion.Libelle}}
                </kal-option>
            </kal-select>
        </kal-form-field>

        <ng-container *ngTemplateOutlet="subventionsErrorTemplate"></ng-container>

        <kal-table #table
                   *ngIf="criterion"
                   [actionable]="displayAddLine"
                   [columns]="columns"
                   [dataSource]="controls"
                   [displayedColumns]="displayedColumns">


            <tr *kalBodyRowDef kal-body-row></tr>
            <tr *kalHeaderRowDef kal-header-row></tr>
            <tr *kalFooterRowDef kal-footer-row></tr>

            <ng-container kalColumn="Valeur">
                <td *kalBodyCell="let row">
                    {{getRuleName(row.get('ChpLstValId').value)}}
                </td>
                <td *kalFooterCell="let row">
                    Subvention par défaut
                </td>
            </ng-container>

            <ng-container kalColumn="De">
                <td *kalBodyCell="let row; let index">
                    <kal-input [formControl]="row.get('De')"
                               [tabIndex]="index"></kal-input>
                </td>
                <td *kalFooterCell="let row" colspan="2">
                    Subvention par défaut
                </td>
            </ng-container>

            <ng-container kalColumn="A">
                <td *kalBodyCell="let row; let index">
                    <kal-input [formControl]="row.get('A')"
                               [tabIndex]="index"></kal-input>
                </td>
                <td *kalFooterCell="let row" style="display: none">
                    <!-- permet de faire un colspan="2" -->
                </td>
            </ng-container>

            <ng-container kalColumn="Od">
                <td *kalBodyCell="let row; let index">
                    <kal-input [formControl]="row.get('Od')" [icon]="inputIcon" [tabIndex]="index"
                               [type]="inputType"></kal-input>
                </td>
                <td *kalFooterCell="let row; let index">
                    <kal-input [formControl]="getDefaultControl('Od')" [icon]="inputIcon"
                               [tabIndex]="index"
                               [type]="inputType"></kal-input>
                </td>
            </ng-container>

            <ng-container kalColumn="Conjoint">
                <td *kalBodyCell="let row; let index">
                    <kal-input [formControl]="row.get('Conjoint')" [icon]="inputIcon" [tabIndex]="index"
                               [type]="inputType"></kal-input>
                </td>
                <td *kalFooterCell="let row; let index">
                    <kal-input [formControl]="getDefaultControl('Conjoint')" [icon]="inputIcon"
                               [tabIndex]="index"
                               [type]="inputType"></kal-input>
                </td>
            </ng-container>

            <ng-container kalColumn="Enfant">
                <td *kalBodyCell="let row; let index">
                    <kal-input [formControl]="row.get('Enfant')" [icon]="inputIcon" [tabIndex]="index"
                               [type]="inputType"></kal-input>
                </td>
                <td *kalFooterCell="let row; let index">
                    <kal-input [formControl]="getDefaultControl('Enfant')" [icon]="inputIcon"
                               [tabIndex]="index"
                               [type]="inputType"></kal-input>
                </td>
            </ng-container>

            <ng-container kalColumn="Externe">
                <td *kalBodyCell="let row; let index">
                    <kal-input [formControl]="row.get('Externe')" [icon]="inputIcon" [tabIndex]="index"
                               [type]="inputType"></kal-input>
                </td>
                <td *kalFooterCell="let row; let index">
                    <kal-input [formControl]="getDefaultControl('Externe')" [icon]="inputIcon"
                               [tabIndex]="index"
                               [type]="inputType"></kal-input>
                </td>
            </ng-container>

            <ng-container kalColumn="ValMin">
                <td *kalBodyCell="let row; let index">
                    <kal-input [formControl]="row.get('ValMin')" [icon]="inputIcon" [tabIndex]="index"
                               [type]="inputType"></kal-input>
                </td>
                <td *kalFooterCell="let row; let index">
                    <kal-input [formControl]="getDefaultControl('ValMin')" [icon]="inputIcon"
                               [tabIndex]="index"
                               [type]="inputType"></kal-input>
                </td>
            </ng-container>

            <ng-container kalColumn="ValMax">
                <td *kalBodyCell="let row">
                    <kal-input [formControl]="row.get('ValMax')" [icon]="inputIcon" [type]="inputType"></kal-input>
                </td>
                <td *kalFooterCell="let row; let index">
                    <kal-input [formControl]="getDefaultControl('ValMax')" [icon]="inputIcon"
                               [tabIndex]="index"
                               [type]="inputType"></kal-input>
                </td>
            </ng-container>

            <ng-container kalColumn="Actions">
                <ng-container [kalColumn]="table.actionColumnName">
                    <td *kalBodyCell="let row; index as idx">
                        <a (click)="deleteLine(idx)" class="gup-O-link -secondary">Supprimer</a>
                    </td>
                </ng-container>
            </ng-container>

        </kal-table>

        <a (click)="addLine()" *ngIf="displayAddLine"
           class="gup-C-moreInfos gup-O-link">
            <kal-icon>add</kal-icon>
            <span>Ajouter une ligne</span>
        </a>
    </ng-template>

    <div class="gup-O-separationLine"></div>

    <div class="subtitle">Paramètres</div>

    <label>Enfants ...</label>

    <div class="type-list-enfant">

        <kal-checkbox formControlName="RglModeleIdEnfDir" label="directs uniquement"></kal-checkbox>
        <kal-checkbox formControlName="RglModeleIdEnfAch" label="à charge uniquement"></kal-checkbox>
        <kal-checkbox formControlName="RglModeleIdEnfHan" label="handicapés"></kal-checkbox>

        <div class="tranche">

            <kal-checkbox formControlName="handleAge" label="âgés de "></kal-checkbox>

            <kal-input formControlName="RglModeleIdAgeEnfMin" type="number"></kal-input>

            <span>à</span>

            <kal-input formControlName="RglModeleIdAgeEnfMax" type="number"></kal-input>

            <span>ans.</span>

        </div>

    </div>

    <div *ngIf="hasAgeValue">

        <kal-form-field *ngIf="referenceMotorDatesList"
                        class="gup-C-formFieldSize--select">
            <kal-select formControlName="IdTypeDateRefPond" label="Date de réference">
                <kal-option *ngFor="let date of referenceMotorDatesList" [value]="date.Id">{{date.Libelle}}</kal-option>
            </kal-select>
        </kal-form-field>

        <div *ngIf="displayChildrenSelectedDateField">

            <app-shared-days-in-month-edit formControlName="DateRefPond"></app-shared-days-in-month-edit>

        </div>

    </div>

    <label>Pondérer selon ...</label>

    <div class="type-list-ponderation">

        <kal-checkbox formControlName="IsPondererTempsTravail"
                      label="le pourcentage de temps de travail"></kal-checkbox>

        <kal-checkbox formControlName="IsPondererMoisPresence" label="les mois de présence"></kal-checkbox>

        <kal-checkbox formControlName="IsPondererMoisEntier" label="Ne prendre que les mois entiers"></kal-checkbox>

    </div>

</div>

<ng-template #subventionsErrorTemplate>
    <p *ngIf="hasSubventionsError"
       class="small gup-U-color--400">
        {{subventionsError}}
    </p>
</ng-template>
